import { ISelectOption } from '@aon/aon-tws-common-ui';
import { ILibraryQuestion as ICommonLibraryQuestion } from '@aon/tws-common-ui-questions/build/lib/models';
import _ from 'lodash';
import Constants from '../constants';
import ContentConstants from '../contentConstants';
import { IBenchmark } from '../models';

const deriveUniqueResponseOptionGroups = (questions: ICommonLibraryQuestion[]): ISelectOption[] => {
	const responseOptionGroups = _(questions)
		.map((q) => q.responseOptionGroup || '')
		.filter((r) => r !== '')
		.uniq()
		.sort()
		.value();

	return responseOptionGroups.map((r) => ({
		name: Constants.FILTER_PREFIX_ROG + r,
		displayText: r,
		group: ContentConstants.FILTER_RESPONSE_OPTION_GROUPS,
	}));
};

const deriveUniqueTags = (questions: ICommonLibraryQuestion[]) => {
	const tags = _(questions)
		.map((q) => q.tagNames || [])
		.flatten()
		.uniq()
		.sort()
		.value();

	return tags.map((t) => ({
		name: Constants.FILTER_PREFIX_TAG + t,
		displayText: t,
		group: ContentConstants.FILTER_TAGS,
	}));
};

const deriveUniqueQuestionTemplates = (questions: ICommonLibraryQuestion[]) => {
	const questionTemplates = _(questions)
		.map((q) => q.templateNames || [])
		.flatten()
		.uniq()
		.sort()
		.value();

	return questionTemplates.map((qt) => ({
		name: Constants.FILTER_PREFIX_QUESTIONTEMPLATE + qt,
		displayText: qt,
		group: ContentConstants.FILTER_QUESTION_TEMPLATES,
	}));
};

const deriveUniqueCultures = (availableCultures: ISelectOption[], questions: ICommonLibraryQuestion[]) => {
	const cultures = _.keyBy(availableCultures, 'name');

	const languages = _(questions)
		.map((q) => q.languages)
		.flatten()
		.uniq()
		.value();

	const languageOptions: ISelectOption[] = languages.map((l) => {
		const culture = cultures[l];
		return {
			name: Constants.FILTER_PREFIX_LANGUAGE + l,
			displayText: culture ? culture.displayText : l,
			group: ContentConstants.FILTER_LANGUAGES,
		};
	});
	return _.orderBy(languageOptions, (l) => l.displayText);
};

const deriveUniqueBenchmarks = (availableBenchmarks: IBenchmark[], questions: ICommonLibraryQuestion[]) => {
	const allBenchmarks = _.keyBy(availableBenchmarks, 'benchmarkId');

	const benchmarkIds = _(questions)
		.map((q) => q.benchmarkIds)
		.flatten()
		.uniq()
		.value();

	const benchmarkOptions: ISelectOption[] = benchmarkIds.map((id) => {
		const benchmark = allBenchmarks[id];
		return {
			name: Constants.FILTER_PREFIX_BENCHMARK + id,
			displayText: benchmark ? benchmark.displayText : id + '',
			group: ContentConstants.FILTER_BENCHMARKS,
		};
	});
	return _.orderBy(benchmarkOptions, (l) => l.displayText);
};

export const QuestionFilterHelper = {
	deriveUniqueBenchmarks,
	deriveUniqueCultures,
	deriveUniqueQuestionTemplates,
	deriveUniqueResponseOptionGroups,
	deriveUniqueTags,
};
